import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { map } from 'rxjs/operators';
import { DigestService, UtilService } from '../services';
import * as moment from 'moment';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    selector: 'user-edit-digest',
    template: `
        <mat-card>
            <mat-card-content fxLayout="column" [formGroup]="form">
                <div *ngIf="config?.unsubscribed" fxLayout="row"  style="padding-bottom: 10px;">
                    <mat-label style="color: red;">* Unsubscribed</mat-label>
                </div>
                <div fxLayout="row" class="item-row" formGroupName="schedule">
                    <mat-slide-toggle formControlName="enabled">{{schedule?.controls.enabled.value ? 'On' : 'Off'}}</mat-slide-toggle>
                </div>
                <div fxLayout="row" class="item-row" style="padding-top: 10px;">
                    <mat-form-field fxFlex="80" >
                        <input matInput placeholder="Subject line of email" formControlName="title">
                    </mat-form-field>
                </div>
                <div formGroupName="schedule" fxLayout="row" class="item-row">
                    <mat-form-field fxFlex="80">
                        <mat-select placeholder="Frequency" formControlName="freq">
                            <mat-option *ngFor="let freq of frequencies" [value]="freq.value">{{ freq.viewValue }}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div fxLayout="row" *ngIf="schedule.controls.freq.value === 'WEEKLY'" formGroupName="schedule" class="item-row">
                    <div fxLayout="column" >
                        <span class="mat-select-placeholder mat-floating-placeholder" style="width: 99px; color: rgba(0, 0, 0, 0.38);">Send Day </span>
                        <div fxLayout="row">
                            <mat-button-toggle-group formControlName="byday" multiple>
                                <mat-button-toggle value="SU">S</mat-button-toggle>
                                <mat-button-toggle value="MO">M</mat-button-toggle>
                                <mat-button-toggle value="TU">T</mat-button-toggle>
                                <mat-button-toggle value="WE">W</mat-button-toggle>
                                <mat-button-toggle value="TH">T</mat-button-toggle>
                                <mat-button-toggle value="FR">F</mat-button-toggle>
                                <mat-button-toggle value="SA">S</mat-button-toggle>
                            </mat-button-toggle-group>
                        </div>
                    </div>
                </div>
                <div fxLayout="row" formGroupName="schedule">
                    <mat-form-field fxFlex="80">
                        <mat-select *ngIf="schedule" placeholder="Timezone" formControlName="timeZone">
                            <mat-option *ngFor="let zone of timezones" [value]="zone.value">{{ zone.viewValue }}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div fxLayout="row" style="padding-top:20px;" formGroupName="schedule">
                        <div class="mat-select-placeholder mat-floating-placeholder" style="width: 99px; color: rgba(0, 0, 0, 0.38);">Send Time </div>
                        <time-picker *ngIf="schedule" formControlName="sendTime"></time-picker>
                </div>
            </mat-card-content>
            <mat-card-actions>
                <button mat-raised-button color="primary" [disabled]="form.invalid" (click)="save()">Save</button>
            </mat-card-actions>
        </mat-card>
    `
})
export class UserEditDigestComponent implements OnChanges {
    @Input() userId: string;
    form: FormGroup;
    frequencies = this.utilService.digestFrequencies;
    timezones = this.utilService.displayTimezones;
    config: any;

    constructor(public snackBar: MatSnackBar,
                private fb: FormBuilder,
                private digestService: DigestService,
                private utilService: UtilService) {}

    ngOnChanges(changes: SimpleChanges): void {
        if (!this.form) {
            this.form = this.fb.group({
                title: [],
                schedule: this.fb.group({
                    enabled: [],
                    byday: [],
                    freq: [],
                    timeZone: [],
                    sendTime: []
                })
            });
        }
        
        if (changes.userId.currentValue) {
            this.digestService.getDigestConfigurationsForUser(this.userId)
            .pipe(map(configs => configs[0]))
            .subscribe(config => {
                config.schedule.sendTime = moment().set({ hour: config.schedule.sendHour, minute: config.schedule.sendMinute });
                this.config = config;
                this.form.patchValue(config);
            });
        }
    }

    get schedule(): FormGroup {
        return this.form?.controls.schedule as FormGroup;
    }

    save() {
        const vals = this.form.value;
        this.config.title = vals.title;
        ['enabled', 'byday', 'freq', 'timeZone'].forEach(key => this.config.schedule[key] = vals.schedule[key]);
        this.config.schedule.sendTime = moment(vals.schedule.sendTime);

        this.digestService.putDigestConfigurationsForUser(this.userId, this.config)
        .subscribe(() => this.snackBar.open(`Digest updated.`, 'OK', { duration: 3000}));
    }
}